var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompensationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 7.5a6.76 6.76 0 016 0m9 3a3 3 0 01-3 3l3-3zM6 6.8a8.316 8.316 0 00-3.4 4.45H.75v6h2.49a8.466 8.466 0 002.01 2.372V22.5c0 .414.336.75.75.75h1.5a.75.75 0 00.75-.75v-1.241a9.51 9.51 0 006 .01v1.23c0 .415.336.75.75.75h1.5a.75.75 0 00.75-.75v-2.862a7.94 7.94 0 003-6.137 8.053 8.053 0 00-3.757-6.706L6 6.8z",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.25.75a3 3 0 110 6 3 3 0 010-6v0z",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgCompensationIcon;